import { useState, useEffect } from "react";
import SkeletonProcess from "./SkeletonProcess.jsx";
//Para PK en concreto añadir id /api/v1/processes/2/?active=true&limit=1
function ProcessMainCard({ configuration }) {
  const [processData, setProcessData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const headers = {
    "Accept-Language": window.location.pathname.split("/")[1],
  }

  useEffect(() => {
    getProcessData();
  }, []);

  const getProcessData = async () => {
    setIsLoading(true);
    fetch(configuration.endpoint, { headers:headers })
    .then((response) => response.json())
    .then((data) => {
      setProcessData(data.results[0]);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  };

  function truncateText( text, wordsMax ) {
    let textTruncate = "";
    if (text !== undefined) {
      const words = text.split(" ");
      const limitWords = wordsMax;
      if (words.length <= limitWords) {
        textTruncate = text;
      } else {
        textTruncate = words.slice(0, limitWords).join(" ") + "...";
      }
    }
    return textTruncate
  }

  let out;
  if (processData) {
    out = (
      <>
        <div className="card-image">
          <img src={processData?.main_image} alt="" />
        </div>
        <div className="card-content">
          <div className="card-process_head">
            <div className="card-process_type">
              <i className={`icon-${processData?.current_phase.phase_type}`} title={processData?.current_phase.phase_type_display}></i>
              <span>{processData?.current_phase.phase_type_display}</span>
            </div>
            <div className="card-process_title"><a href={processData?.url}>{processData?.name}</a></div>
          </div>
          <div className="card-process_info" dangerouslySetInnerHTML={{ __html: truncateText(processData?.description, 45) }} />
          <div className="card-process_action">
            <a href={processData?.url} className="main-button">
              {configuration.translations.takePart}
              <i className="icon-flecha_dch"></i>
            </a>
          </div>
        </div>
      </>
    );
  } else {
    out = "";
  }
  return (
    <>
      {isLoading ? <SkeletonProcess /> : out}
    </>
  );
}

export default ProcessMainCard;
